import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOrderItems = get('reservation.orderItems');

export const getOrdersByReservation = createSelector(
  getOrderItems,
  get('ordersByReservation')
);

export const getMeta = createSelector(getOrderItems, get('meta'));

export const getIsFetching = createSelector(getOrderItems, get('fetching'));
export const getIsFetched = createSelector(getOrderItems, get('fetched'));

export const getFetchingError = createSelector(
  getOrderItems,
  get('fetchingError')
);
